import { render, staticRenderFns } from "./employees-item-grant-confirm.vue?vue&type=template&id=b6057a20"
import script from "./employees-item-grant-confirm.vue?vue&type=script&lang=js"
export * from "./employees-item-grant-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports